module.exports = "/_next/static/images/ab944d70a66e645b5469df080a208bbe-roxinho-card-with-phone-md@3x.jpg";